import * as React from "react";
import { GetBookOfMindQuotesForDisplay } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/BookOfMindQuoteDisplay";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { SetBookOfMindState } from "../../Helpers/BookOfMindHelpers";

export function LoadBookOfMindQuotesForDisplay(state: IBookOfMindState) {
    React.useEffect(() => {
        const chronologicalQuotes = state.chronologicalQuotes;

        if (chronologicalQuotes.length === 0) {
            return;
        }

        const filteredQuotes = GetBookOfMindQuotesForDisplay(
            chronologicalQuotes,
            state.displayOrder,
            state.searchText
        );

        SetBookOfMindState({
            remainingQuotesToDisplay: filteredQuotes,
            totalQuotesToDisplay: filteredQuotes.length,
        });
    }, [
        state.chronologicalQuotes,
        state.refreshTimeStamp,
        state.searchText,
    ]);
}
